import { gql } from "@apollo/client";
import type { TypedDocumentNode } from "@apollo/client";

export type CareerConsultantOption = {
  id: string;
  name: string;
  email: string | null;
  photo?: string | null;
};

export type CareerConsultantsQueryResponse = {
  careerConsultants: CareerConsultantOption[];
};

export type CareerConsultantsQueryVariables = {
  search?: string;
};

export const CAREER_CONSULTANTS_QUERY: TypedDocumentNode<
  CareerConsultantsQueryResponse,
  CareerConsultantsQueryVariables
> = gql`
  query CareerConsultants($search: String) {
    careerConsultants(search: $search) {
      id
      name
      email
      photo
    }
  }
`;

export const CREATE_JOB_POST_MUTATION = gql`
  mutation CreateJobPost($input: BackofficeCreateJobPostInput!, $application: BackofficeJobApplicationFormInput) {
    createJobPost(input: $input, application: $application) {
      success
      message
      code
      jobPost {
        id
        name
      }
    }
  }
`;

export const GET_JOB_CATEGORIES_QUERY = gql`
  query GetJobCategories {
    jobPostCategories {
      name
    }
  }
`;

export const UPDATE_JOB_POST_MUTATION = gql`
  mutation PatchJobPost($input: BackofficePatchJobPostInput!, $application: BackofficeJobApplicationFormInput) {
    patchJobPost(input: $input, application: $application) {
      success
      message
      jobPost {
        id
        name
        status
        stage
        owner {
          id
          name
          email
          photo
        }
        owners {
          id
          name
          email
          photo
        }
      }
    }
  }
`;
